import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { DashboardService } from '../../../_services/admin/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  totalContact = '0';
  totalEnquiry = '0';
  totalProduct = '0';
  totalCategory = '0';

  constructor(private myTitle: Title, private dashboardService: DashboardService) {
  }

  ngOnInit() {
    this.myTitle.setTitle('Dashboard | ' + environment.commonTitle);
    this.getTotalCount();
  }

  getTotalCount() {
    this.dashboardService.getTotalCount().subscribe(result => {
      if (result.data) {
        const resdata = result.data;
        this.totalContact = resdata.totalContact;
        this.totalProduct = resdata.totalProduct;
        this.totalEnquiry = resdata.totalEnquiry;
        this.totalCategory = resdata.totalCategory;
      }
    });
  }
}
